export default "__VITE_ASSET__0ed40237__"